// Same-page "#anchor" links (bv. "/#bureauhoogte-rekentool", of de
// inhoudsopgave in snippets/artikel-body.liquid) werken op desktop
// (>=990px) niet vanzelf: Horizon's "squeeze layout" zet <html>/<body>
// op overflow: hidden en scrollt in plaats daarvan .page-wrapper (zie
// assets/scroll-container.js). De browser weet daar niets van — die
// scrollt bij een hash-link altijd het document zelf, wat op desktop
// dus niets doet. Dit script doet hetzelfde, maar dan op het echte
// scroll-element voor het huidige breekpunt.
import { getScrollContainer } from '@theme/scroll-container';

/**
 * @param {Element} target
 * @returns {number}
 */
function getScrollMarginTop(target) {
  const value = getComputedStyle(target).scrollMarginTop;
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * @param {Element} target
 * @param {ScrollBehavior} behavior
 */
function scrollToElement(target, behavior) {
  const container = getScrollContainer();
  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const offset = targetRect.top - containerRect.top + container.scrollTop - getScrollMarginTop(target);

  container.scrollTo({ top: Math.max(0, offset), behavior });
}

/**
 * @param {string} hash - Includes the leading "#".
 * @returns {Element | null}
 */
function resolveHashTarget(hash) {
  if (!hash || hash === '#') return null;

  let id;
  try {
    id = decodeURIComponent(hash.slice(1));
  } catch (_error) {
    return null;
  }

  // "#shopify-section-<sectie-id>" (bv. in de inhoudsopgave van de
  // B2B-pagina): Shopify zet er in de echte id nog een template-prefix
  // voor ("shopify-section-template--123__<sectie-id>"), die in een
  // richtext-link niet bekend is. Val daarom terug op de achtervoegsel.
  const exact = document.getElementById(id);
  if (exact || !id.startsWith('shopify-section-')) return exact;

  const sectionId = id.slice('shopify-section-'.length);
  return document.querySelector(`[id^="shopify-section-"][id$="__${CSS.escape(sectionId)}"]`);
}

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!(link instanceof HTMLAnchorElement)) return;

  let url;
  try {
    url = new URL(link.href, window.location.href);
  } catch (_error) {
    return;
  }

  // Alleen ingrijpen als het echt dezelfde pagina is (zelfde origin, pad
  // en query) — anders laten we normale navigatie gewoon zijn gang gaan.
  if (
    url.origin !== window.location.origin ||
    url.pathname !== window.location.pathname ||
    url.search !== window.location.search
  ) {
    return;
  }

  const target = resolveHashTarget(url.hash);
  if (!target) return;

  event.preventDefault();
  history.pushState(null, '', url.hash);
  scrollToElement(target, 'smooth');
});

if (window.location.hash) {
  const target = resolveHashTarget(window.location.hash);
  if (target) {
    // Wachten tot layout/fonts geladen zijn, anders klopt de gemeten
    // positie nog niet.
    requestAnimationFrame(() => scrollToElement(target, 'instant'));
  }
}
